<template>
  <v-dialog
    v-if="!isMobileApp"
    :value="value"
    scrollable
    :width="width"
    :fullscreen="isFullScreen"
    :persistent="persistent"
    :max-width="maxWidth"
    transition="dialog-bottom-transition"
    :content-class="`${headerType === 'information' ? 'scroll-bar-top-offset' : ''} ${
      !loading &&
      !$slots.actions &&
      !$vuetify.breakpoint.smAndDown &&
      (($vuetify.breakpoint.smAndDown && !mobileButtons && !buttons) ||
        (!$vuetify.breakpoint.smAndDown && !buttons))
        ? 'scroll-bar-bottom-offset'
        : ''
    } ${
      !$slots.title && !title && !showCloseButton && !$vuetify.breakpoint.smAndDown
        ? 'scroll-bar-top-small-offset'
        : ''
    } ${contentClass}`"
    @input="e => $emit('input', e)"
    @click:outside="persistent ? null : $emit('input', false)"
    @keydown.esc="persistent ? null : $emit('input', false)"
  >
    <div v-if="!persistent && !isFullScreen && headerType === 'none'" class="dialog-floating-close">
      <v-btn fab @click="$emit('input', false)">
        <v-icon>$cross</v-icon>
      </v-btn>
    </div>

    <DialogContent
      :fullscreen="isFullScreen"
      :show-back-arrow="showBackArrow"
      :title-left="titleLeft"
      :left-header-icon="leftHeaderIcon"
      :left-header-icon-type="leftHeaderIconType"
      :left-header-icon-component="leftHeaderIconComponent"
      :text-class="textClass"
      :show-close-button="showCloseButton"
      :header-type="headerType"
      :dialog-value="value"
      :title="title"
      :show-title-in-content="showTitleInContent"
      :show-progress-bar="showProgressBar"
      :progress-bar-value="progressBarValue"
      :buttons="buttons"
      :mobile-buttons="mobileButtons"
      :loading="loading"
      :show-title-before-scroll="showTitleBeforeScroll"
      :title-bottom-margin="titleBottomMargin"
      :persistent="persistent"
      :content-justify="dialogContentJustify"
      :content-display-classes="dialogContentDisplayClasses"
      @clickBack="$emit('clickBack')"
      @close="$emit('input', false)"
    >
      <template v-if="$slots.title" #title>
        <slot name="title" />
      </template>
      <template v-if="$slots.text" #text>
        <slot name="text" />
      </template>
      <template v-if="$slots.leftIcon" #leftIcon>
        <slot name="leftIcon" />
      </template>
      <template v-if="$slots.actions" #actions>
        <slot name="actions" />
      </template>
    </DialogContent>
  </v-dialog>
  <DialogContent
    v-else-if="value"
    class="mobile_app_dialog"
    :fullscreen="isFullScreen"
    :show-back-arrow="showBackArrow"
    :title-left="titleLeft"
    :left-header-icon="leftHeaderIcon"
    :left-header-icon-type="leftHeaderIconType"
    :left-header-icon-component="leftHeaderIconComponent"
    :text-class="textClass"
    :show-close-button="showCloseButton"
    :header-type="headerType"
    :dialog-value="value"
    :title="title"
    :show-title-in-content="showTitleInContent"
    :show-progress-bar="showProgressBar"
    :progress-bar-value="progressBarValue"
    :buttons="buttons"
    :mobile-buttons="mobileButtons"
    :loading="loading"
    :show-title-before-scroll="showTitleBeforeScroll"
    :title-bottom-margin="titleBottomMargin"
    :persistent="persistent"
    :content-justify="dialogContentJustify"
    :content-display-classes="dialogContentDisplayClasses"
    @clickBack="$emit('clickBack')"
    @close="$emit('input', false)"
  >
    <template v-if="$slots.title" #title>
      <slot name="title" />
    </template>
    <template v-if="$slots.text" #text>
      <slot name="text" />
    </template>
    <template v-if="$slots.leftIcon" #leftIcon>
      <slot name="leftIcon" />
    </template>
    <template v-if="$slots.actions" #actions>
      <slot name="actions" />
    </template>
  </DialogContent>
</template>

<script>
export default {
  name: 'UlDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    width: {
      type: [String, Number],
      default: 492
    },
    showBackArrow: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    titleLeft: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    textClass: {
      type: String,
      default: 'px-4 px-md-10'
    },
    fullscreen: {
      type: Boolean,
      default: null
    },
    maxWidth: {
      type: [String, Number],
      default: null
    },
    leftHeaderIcon: {
      type: String,
      default: null
    },
    leftHeaderIconType: {
      validator(value) {
        return ['static', 'animated'].includes(value);
      },
      default: 'static'
    },
    leftHeaderIconComponent: {
      type: String,
      default: null
    },
    headerType: {
      validator(value) {
        return ['navigation', 'information', 'none'].includes(value);
      },
      default: 'navigation'
    },
    title: {
      type: String,
      required: false
    },
    showTitleInContent: {
      type: Boolean,
      default: true
    },
    showTitleBeforeScroll: {
      type: Boolean,
      default: true
    },
    buttons: {
      type: Array,
      required: false
    },
    mobileButtons: {
      type: Array,
      required: false
    },
    showProgressBar: {
      type: Boolean,
      default: false
    },
    progressBarValue: {
      type: Number,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    },
    titleBottomMargin: {
      type: String,
      default: 'mb-4'
    },
    dialogContentJustify: {
      type: String,
      default: 'start'
    },
    dialogContentDisplayClasses: {
      type: String,
      default: 'd-flex d-md-block'
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    showCloseButton() {
      return (
        !this.persistent &&
        (this.showClose || (!this.showClose && this.$vuetify.breakpoint.smAndDown))
      );
    },
    isFullScreen() {
      return this.fullscreen !== false && (this.fullscreen || this.$vuetify.breakpoint.smAndDown);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-floating-close {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 48px;
  z-index: 1;
}
</style>
